import c from 'classnames';

import { Typography } from '@repo/ui';

import styles from './HealthFormsStepBar.module.css';

export type HealthFormsStepBarProps = {
  total: number;
  currentIndex: number;
  label: string;
  currentProgress?: number;
  className?: string;
};

export const HealthFormsStepBar = ({
  total,
  currentIndex,
  label,
  currentProgress = 1,
  className,
}: HealthFormsStepBarProps) => (
  <div className={c(styles.sectionHeader, className)}>
    <div className={styles.progressBar} data-testid='health-forms-step-bar'>
      {Array.from({ length: total }).map((_, index) => {
        const fillPercent =
          index < currentIndex
            ? 100
            : index === currentIndex
              ? Math.round(Math.min(Math.max(currentProgress, 0), 1) * 100)
              : 0;
        return (
          <div
            key={index}
            className={styles.progressSegment}
            data-testid='health-forms-step-bar-segment'
          >
            <div
              className={styles.progressSegmentFill}
              style={{ width: `${fillPercent}%` }}
              data-testid='health-forms-step-bar-fill'
            />
          </div>
        );
      })}
    </div>
    <Typography variant='label' className='grey-text'>
      {label}
    </Typography>
  </div>
);

export default HealthFormsStepBar;
